import { render, staticRenderFns } from "./MobileTopicInfo.vue?vue&type=template&id=d045569a&scoped=true"
import script from "./MobileTopicInfo.vue?vue&type=script&lang=js"
export * from "./MobileTopicInfo.vue?vue&type=script&lang=js"
import style0 from "./MobileTopicInfo.vue?vue&type=style&index=0&id=d045569a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d045569a",
  null
  
)

export default component.exports